exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab{position:relative;height:3.75rem;line-height:3.4375rem;background:#516a7d;border-top:.3125rem solid #516a7d;font-size:1.125rem;text-align:center;text-decoration:none;text-transform:uppercase;transition:background-color .1s,border-color .1s,color .1s;width:50%;color:#8daec3}.tab.active-tab{background-color:#fff;border-top-color:#9ecef3;color:#374651}.tab:first-child{border-top-left-radius:.3125rem}.tab:first-child.active-tab{border-top-left-radius:0}.tab:last-child{border-top-right-radius:.3125rem}.tab:last-child.active-tab{border-top-right-radius:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Tab/Tab.scss
// module id = 692
// module chunks = 0